import type { ComputedRef } from 'vue'
import {
  usarCatalogoQuery,
  usarContextoCatalogo,
  type EstadoCatalogoQuery,
} from '@next/compartilhados/catalogos'

import {
  DESCRITOR_CATALOGO_EMPREGADO,
  type OpcaoEmpregado,
} from '../catalogo-empregado.tipos'
import { usarOperacoesCatalogoEmpregado } from './catalogo-empregado.injecao'

export const usarCatalogoEmpregado = (
  habilitado?: ComputedRef<boolean>,
): EstadoCatalogoQuery<OpcaoEmpregado> => {
  const operacoes = usarOperacoesCatalogoEmpregado()
  return usarCatalogoQuery({
    catalogo: DESCRITOR_CATALOGO_EMPREGADO,
    contexto: usarContextoCatalogo(),
    consultar: operacoes.listarOpcoes,
    ...(habilitado ? { habilitado } : {}),
  })
}
